import { render, staticRenderFns } from "./BoardEdit.vue?vue&type=template&id=36df7884&scoped=true&"
import script from "./BoardEdit.vue?vue&type=script&lang=js&"
export * from "./BoardEdit.vue?vue&type=script&lang=js&"
import style0 from "./BoardEdit.vue?vue&type=style&index=0&id=36df7884&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36df7884",
  null
  
)

export default component.exports